/*
 * patient-intake (zod)
 */
import { createInsertSchema, createSelectSchema } from "drizzle-zod"
import * as z from "zod"
import { globalCreateExclude, globalUpdateExclude } from "../utils/constants"
import { patientIntakes, type PharmaEntry } from "./patient-intake.schema"

const pharmaEntrySchema = z.object({
	name: z.string(),
	prescriptionNames: z.string().optional().nullable(),
})

/* Select */
export type PatientIntake = z.infer<typeof selectPatientIntakeSchema>
export const selectPatientIntakeSchema = createSelectSchema(patientIntakes).extend({
	veteranStatus: z.array(z.string()).optional().nullable(),
	conventionalTreatments: z.array(z.string()).optional().nullable(),
	therapies: z.array(z.string()).optional().nullable(),
	psychiatricPharmaceuticals: z.array(pharmaEntrySchema).optional().nullable(),
	painPharmaceuticals: z.array(pharmaEntrySchema).optional().nullable(),
})

/* Filters */
export type PatientIntakeFilters = z.infer<typeof patientIntakeFiltersSchema>
export const patientIntakeFiltersSchema = z.object({
	id: z.string().optional(),
	patientId: z.string().optional(),
	isLatest: z.boolean().optional(),
	active: z.boolean().optional(),
})

/* Create */
export const createPatientIntakeSchema = createInsertSchema(patientIntakes)
	.partial(globalCreateExclude)
	.extend({
		veteranStatus: z.array(z.string()).optional().nullable(),
		conventionalTreatments: z.array(z.string()).optional().nullable(),
		therapies: z.array(z.string()).optional().nullable(),
		psychiatricPharmaceuticals: z.array(pharmaEntrySchema).optional().nullable(),
		painPharmaceuticals: z.array(pharmaEntrySchema).optional().nullable(),
	})
export type CreatePatientIntake = z.infer<typeof createPatientIntakeSchema>

/* Update */
export const updatePatientIntakeSchema = createInsertSchema(patientIntakes)
	.omit(globalUpdateExclude)
	.partial()
	.required({ id: true })
	.extend({
		veteranStatus: z.array(z.string()).optional().nullable(),
		conventionalTreatments: z.array(z.string()).optional().nullable(),
		therapies: z.array(z.string()).optional().nullable(),
		psychiatricPharmaceuticals: z.array(pharmaEntrySchema).optional().nullable(),
		painPharmaceuticals: z.array(pharmaEntrySchema).optional().nullable(),
	})
export type UpdatePatientIntake = z.infer<typeof updatePatientIntakeSchema>

export type { PharmaEntry }
